<div class="flex align-items-center">
  <p-dropdown
    [options]="emails"
    optionLabel="email"
    [filter]="true"
    filterBy="email"
    [showClear]="true"
    placeholder="Choose the email"
    optionValue="email"
    [appendTo]="'body'"
    [(ngModel)]="selectedValue"
    class="w-full border-noround-right"
  >
  </p-dropdown>
  <p-button
    label="Add"
    severity="success"
    class="border-noround-left"
    (onClick)="addEmail()"
    [disabled]="!selectedValue"
  ></p-button>
</div>
